export default __webpack_public_path__ + "static/media/1450.9e500b4a.png";